<h2>Editor</h2>
<input type="file" (change)="onFileUpload($event.target.files[0])">
<img *ngFor="let image of images$ | async" [src]="image" alt="Uploaded image">
<h2>Cropper</h2>
<input type="file" (change)="onCropperUpload($event.target.files[0])">
